export interface SubtitleCue {
  textEn: string;
  textZh: string;
  startMs: number;
  endMs: number | null;
}

export function parseSrt(text: string): SubtitleCue[] {
  const blocks = text.replace(/^\uFEFF/, '').split(/\r?\n\r?\n/);
  const cues: SubtitleCue[] = [];
  for (const block of blocks) {
    const lines = block.split(/\r?\n/).filter((l) => l.trim().length > 0);
    if (lines.length < 2) continue;
    const timeLine = lines[0]!.includes('-->') ? lines[0]! : lines[1];
    if (!timeLine || !timeLine.includes('-->')) throw new Error('INVALID_SRT');
    const [startRaw, endRaw] = timeLine.split('-->').map((s) => s.trim());
    const startMs = parseSrtTime(startRaw ?? '');
    const endMs = parseSrtTime(endRaw ?? '');
    if (startMs === null || endMs === null) throw new Error('INVALID_SRT');
    const body = lines.slice(timeLine === lines[0] ? 1 : 2);
    cues.push({
      textEn: body[0] ?? '',
      textZh: body[1] ?? '',
      startMs,
      endMs,
    });
  }
  return cues;
}

export function parseLrc(text: string): SubtitleCue[] {
  const cues: SubtitleCue[] = [];
  for (const raw of text.split(/\r?\n/)) {
    const match = /^\[(\d{1,2}):(\d{2})(?:\.(\d{1,3}))?\](.*)$/.exec(raw.trim());
    if (!match) continue;
    const min = Number(match[1]);
    const sec = Number(match[2]);
    const frac = match[3] ?? '0';
    const startMs = min * 60_000 + sec * 1000 + Number(frac.padEnd(3, '0').slice(0, 3));
    cues.push({ textEn: match[4]?.trim() ?? '', textZh: '', startMs, endMs: null });
  }
  for (let i = 0; i < cues.length - 1; i += 1) {
    cues[i]!.endMs = cues[i + 1]!.startMs;
  }
  return cues;
}

function parseSrtTime(value: string): number | null {
  const match = /(\d{1,2}):(\d{2}):(\d{2})[,.](\d{1,3})/.exec(value);
  if (!match) return null;
  return (
    Number(match[1]) * 3_600_000 +
    Number(match[2]) * 60_000 +
    Number(match[3]) * 1000 +
    Number(match[4].padEnd(3, '0').slice(0, 3))
  );
}
